export const Table = {}

export default Table
